import { Model } from '@appstrax/services/database';

/**
 * Generic per-project document store for section state.
 * Examples of keys:
 * - define.chat
 * - define.definition
 * - tickets.board
 * - marketplace.filters
 */
export class MachineDoc extends Model {
  public projectId: string = '';
  public key: string = '';
  // IMPORTANT:
  // `@appstrax/services`'s ServiceHelper assigns nested objects by *recursing into existing keys*.
  // If we default this to `{}`, the mapper will recurse into it and copy nothing (since it has no keys),
  // resulting in an empty payload after refresh.
  //
  // By defaulting to a non-object sentinel, the mapper will take the "else" branch and assign the
  // entire payload object directly (which is what we want for arbitrary doc payloads).
  public data: any = '';
  public version: number = 1;
}

